import { render } from "./AllowAccess.vue?vue&type=template&id=4e2b2c04"
import script from "./AllowAccess.vue?vue&type=script&lang=js"
export * from "./AllowAccess.vue?vue&type=script&lang=js"

import "./AllowAccess.vue?vue&type=style&index=0&id=4e2b2c04&lang=css"
script.render = render

export default script